export default "__VITE_ASSET__CvGyqF$m__"